
import { useEffect } from "react";
import useRefreshToken from "./useRefreshToken";
import { useAuth } from "./useAuth";
import { axiosPrivate } from "../../../setup/axios/axios";

const useAxiosPrivate = () => {
    const refresh = useRefreshToken();
    const { UserToken } = useAuth();

    useEffect(() => {

        const requestIntercept = axiosPrivate.interceptors.request.use(
            config => {
                if (!config.headers['Authorization']) {
                    config.headers['Authorization'] = `Bearer ${UserToken?.token}`;
                }
                return config;
            }, (error) => Promise.reject(error)
        );




        const responseIntercept = axiosPrivate.interceptors.response.use(
            response => response,
            async (error) => {

                console.log('error .message : ', error.message);
                error.originalMessage = error.message;
                Object.defineProperty(error, "message", {
                    get: function () {
                        console.log('error.response : ', error.originalMessage);
                        if (!error.response) {
                            return error.originalMessage;
                        }
                        return JSON.stringify(error.response.data);

                    }
                });

                const prevRequest = error?.config;
                if (error?.response?.status === 403 && !prevRequest?.sent) {
                    prevRequest.sent = true;
                    const newAccessToken = await refresh();
                    prevRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                    return axiosPrivate(prevRequest);
                }

                return Promise.reject(error);
            }
        );

        return () => {
            axiosPrivate.interceptors.request.eject(requestIntercept);
            axiosPrivate.interceptors.response.eject(responseIntercept);
        }
    }, [UserToken, refresh])

    return axiosPrivate;
}

export default useAxiosPrivate;